export default __webpack_public_path__ + "static/media/398.16b88251.png";